import { useSymbolsStore } from '../store/Symbols';
import { useSymbolsRender } from '../utils/useRender';
export var ValueQuote = props => {
  var {
    ValueQuote: Comp = {}
  } = useSymbolsStore();
  useSymbolsRender(Comp, props, 'ValueQuote');
  return null;
};
ValueQuote.displayName = 'JVR.ValueQuote';